// Mini Basket Style
function hideBasket() {
    $(".SepetProducts").stop().animate(200, function () {
        $(".SepetProducts").stop().hide();
    });
}

function setContentHeight() {
    var headerHeight = $("header").height();
    var headerTop = $("header").css("top").replace("px", "");
    var deviceHeight = $(window).height();
    var BasketButtonHeight = $(".SepetProducts .PriceAndButton").height();
    var CardTitleHeight = $(".SepetProducts .CartTitle").height();
    var MarginAndPadding = 80;
    var MiniBasketHeight = $(window).height() - headerHeight - headerTop;

    if ($(window).width() < 991) {
        $(".SepetProducts").css("width", $(window).width());
    }

    //var ContentHeight = MiniBasketHeight / 100 * 45;
    var ContentHeight = deviceHeight - headerHeight - headerTop - BasketButtonHeight - CardTitleHeight - MarginAndPadding;

    if ($(window).width() < 991 && $(window).height() > 700) {
        ContentHeight = MiniBasketHeight / 100 * 65;
    }
    else if ($(window).width() < 991 && $(window).height() <= 700) {
        ContentHeight = MiniBasketHeight / 100 * 55;
    }

    $(".BasketCenterContent").height(ContentHeight);
    $(".BasketCenterContent").css("max-height", ContentHeight);

    if ($(window).width() < 991) {
        MiniBasketHeight = $(window).height() - headerHeight + $(".ProductOptions .BasktButtons").height() + 50;
    }

    $(".SepetProducts").height(MiniBasketHeight);
    $(".SepetProducts").css("max-height", MiniBasketHeight);
}

function toggleBasket() {
    if ($(".SepetProducts").is(":visible")) {
        $(".SepetProducts").stop().animate(200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped").removeClass("BackDropped");
            $("body").removeClass("no-scroll");
        });
    } else {
        $(".SepetProducts").stop().animate(200, function () {
            $(".SepetProducts").stop().show();
            setContentHeight();
            $("body").addClass("BasketDropped");
            $("body").addClass("no-scroll");
        });
    }
}
// End Mini Basket Style

// Mini Basket Operations
function RemoveFromCardForMiniCard(id, langId, allRemove, el) {

    var UserID = $('#UserID').val();

    if (!UserID || UserID == "0")
        UserID = "unknown";

    var ProductName = el.attr("data-productname");

    var ProductQuantity = el.attr("data-quantity");

    var stockQuantity = el.attr("data-stockQuantity");
    var ColorName = el.attr("data-colorname");
    var ProductAmount = el.attr("data-productamount");
    //var ItemID = el.attr("data-id");
    var brandNameGetSepetIcerik = el.attr("data-brandNameGetSepetIcerik");
    var CartCatName = el.attr("data-catAddedEnteg");
    var ListPosition = el.attr("data-listposition");

    var ColorCode = el.attr("data-colorcode");
    var ProductCode = el.attr("data-productcode");

    var ProductID = el.attr("data-productid");
    var SizeName = el.attr("data-size");

    var vp = $('.SepetRow');
    var Email = vp.attr('data-userEmail');
    var GSM = vp.attr('data-userGsm');
    var Gender = vp.attr('data-userGender');
    var HashedEmail = vp.attr('data-hashedEmail');
    var HashedGsm = vp.attr('data-hashedGsm');
    var gtagProductUrl = vp.attr('data-producturl');

    var location = window.location.href;

    basketElement = $("#UserMenus .SepetProducts .BasketContainer");

    GenerateLocalLoading(basketElement, "show");

    $.ajax({
        type: 'get',
        url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
        data: 'id=' + id + "&langID=" + langId + allRemove,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.Sonuc == true) {

                $.ajax({
                    type: 'get',
                    url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                    data: "",
                    async: false,
                    contentType: "application/json; charset=utf-8",
                    dataType: 'text',
                    success: function (dt) {
                        $("#UserMenus  #UserAndBasket").html(dt);
                        toggleBasket();
                        setContentHeight();

                        var AddToCartId = ProductCode + "-R" + ColorCode;

                        //remove_from_cart
                        dataLayer.push({ ecommerce: null }); // clear the previous ecommerce object.
                        dataLayer.push({
                            event: "ecom_event",
                            event_category: "ecommerce",
                            event_action: "remove_from_cart",
                            ecommerce: {
                                items: [{
                                    item_id: AddToCartId, //Type: String
                                    item_group_id: ProductCode, //Type: String
                                    item_name: ProductName, //Type: String
                                    currency: "TRY", //Type: String
                                    discount: null, //Type: Float
                                    index: parseInt(ListPosition), //Type: Integer, Desciption: Position in the list
                                    item_brand: "BSL", //Type: String
                                    item_category: CartCatName, //Type: String, Description: Main category of the product
                                    item_category2: null, //Type: String, Description: Type of the product
                                    item_list_id: null, //Type: String
                                    item_list_name: CartCatName, //Type: String
                                    item_variant: SizeName, //Type: String, Description: Size
                                    item_size: SizeName, //Type: String
                                    item_color: ColorName, //Type: String
                                    price: parseFloat(ProductAmount), //Type: Float
                                    quantity: 1, //Type: Integer
                                    stock: parseInt(stockQuantity)
                                }]
                            }
                        });
                    },
                    error: function () {
                        GenerateLocalLoading(basketElement, "hide");
                    }
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }
        },
        error: function () {
            GenerateLocalLoading(basketElement, "hide");
        }
    });
}

function GetSepetIcerik(callback) {
    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
        data: "",
        async: true,
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: 'text',
        success: function (dt) {
            //$("#UserAndBasket").html(dt);

            if ($("#LangSelectionNeed").length > 0) {
                ShowLangAreaForChange();
            }

            if ($("#WindowSizeNotSetted").length > 0) {
                SetWindowSize();
            }

            callback(dt);

            //if (openBasket != null && openBasket != undefined && openBasket) {
            //    toggleBasket();
            //}
        }
    });
}
// End Mini Basket Operations

// Product List

// End Product List

// Product Detail
function AddToCard(param, callback) {
    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
        data: param,
        dataType: 'json',
        async: true,
        success: function (dt) {
            callback(dt);
        }
    });
}
// Product Detail

// Combine
function AddCombineToBasket(basketButton, NormalText, data) {
    GenerateLocalLoading($(".ProductDetail.Combines"), "show");

    $.ajax({
        type: 'GET',
        url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddCombineToCart",
        data: data,
        dataType: 'json',
        async: true,
        success: function (dt) {
            basketButton.text(NormalText);

            if (dt.Sonuc == true) {
                GetSepetIcerik(function (dt) {
                    $("#UserAndBasket").html(dt);
                    toggleBasket();
                });
            }
            else {
                SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
            }

            GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
        }
    });
}
// End Combine